// @flow
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { tripica } from '../../api';
import { setTimeline } from './actions';
import { setLoading } from '../LoadingStatus';
import type { TimelineActionType } from './actions';
import HandleErrorService from '../../lib/handleError';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchTimelineSaga(action: TimelineActionType): Generator<*, *, *> {
  if (action.type !== 'FETCH_TIMELINE') return; // for flow

  const { refresh, hideErrors } = action.payload;

  if (refresh) yield put(setLoading('fetchTimeline', true));

  try {
    const timeline = yield call([tripica, 'getTimeline']);
    yield put(setTimeline(timeline));
  } catch (error) {
    WizzeeLog.warn('[saga] fetchTimelineSaga');
    if (!hideErrors) {
      yield call(HandleErrorService.showToastError, error);
    }
  } finally {
    if (refresh) yield put(setLoading('fetchTimeline', false));
  }
}

export default function*(): Generator<*, *, *> {
  yield all([takeEvery('FETCH_TIMELINE', fetchTimelineSaga)]);
}
